import React from "react";
import "./style.css";

const Loading = () => {
  return <div className="loading-section">
    <div className="loading-sec"></div>
  </div>
};

export default Loading;
